<div class="row mb-4">
  <div class="col">
    <div class="card " style=" overflow-x:hidden;
      overflow-y:visible;
      height:800px;">
      <!-- <div    class="card-body" style="padding:55px;"> -->

      <div class="row mb-4">
        <div class="col">
          <div class="card ">
            <div class="text-end mt-4">
              <button class="btn" (click)="save()">Save
              </button>
              <button class="btn ms-5 me-2" (click)="close()">Close</button>
            </div>

            <div class="card-body" style="padding:85px;">

              <div class="row mt-4">
                <h3><b>Participant Agreement</b></h3>
              </div>

              <div class="row mt-4">
                <p>The participant is set-up as a household employer responsible for hiring and managing
                  employees. The employer can be the person receiving services or their representative. The
                  person who has authority to sign documents related to employer set-up is:</p>
                <ul style="margin-left:30px">
                  <li>An adult participant</li>
                  <li>
                    A parent signing for a minor

                  </li>
                  <li>A guardian (a copy of the guardian paperwork must be provided)</li>
                </ul>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; is a 
                  Community First Service and Support (CFSS) enrolled with the Department of Human
                Services (DHS) as a MN Health Care Provider. &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; CFSS acts as a
                Fiscal/Employer Agent
                under <input type="text" class="form-control mb-2"
                  [(ngModel)]="OnboardClientDocumentBO.participantAgreementTemplateBO.CFSSAct"
                  style="width: 100px;display: inline-block;"> and is responsible for enrolling employees; processing
                timesheets, invoices, and reimbursements; tax filing; billing and program reporting.
              </div>
              <div class="row mt-2">
                The agreement takes effect after intake completion and renews on the next plan’s start date or
                date of that plan’s lead agency signature, whichever is later. To avoid service gaps, plans should
                be submitted to the lead agency 30 days prior to the current plan’s expiration.
              </div>
              <div class="row mt-2">
                Services start when &nbsp; <b style="display: inline-block">&nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; CFSS:
              </div>
              <ul style="margin-left:30px">
                <li>receives a service authorization and plan from the lead agency
                </li>
                <li>an employer is set up with Workers’ Compensation if needed and</li>
                <li>enrolled employees have successfully completed a background check</li>
              </ul>

              <div class="row mt-2">
                <p>Fees are charged according to DHS published rates. In addition, there are employer taxes and
                  benefits billed to the budget based on the employer’s experience and the age and relationship
                  of the employee to the employer. &nbsp; <b style="display: inline-block">&nbsp; <b
                      style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;</b>&nbsp; CFSS fees are <input
                    type="text" class="form-control mb-2"
                    [(ngModel)]="OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithStaffing"
                    style="width: 100px;display: inline-block;"> &nbsp;/month for a
                  CDCS budget with
                  staffing; <input type="text" class="form-control mb-2"
                    [(ngModel)]="OnboardClientDocumentBO.participantAgreementTemplateBO.cdcsBudgetwithGoods"
                    style="width: 100px;display: inline-block;"> &nbsp;/month for a
                  CDCS budget with goods only; and <input type="text" class="form-control mb-2"
                    [(ngModel)]="OnboardClientDocumentBO.participantAgreementTemplateBO.csgBudget"
                    style="width: 100px;display: inline-block;"> &nbsp;/month for a CSG
                  budget.</p>
              </div>
              <div class="row mt-2">
                <h3><b>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS Roles and
                    Responsibilities </b></h3>
              </div>
              <div class="row mt-2">
                Acts as third-party designee and obtains an Employer Identification Number (EIN) for the
                participant with completion and filing of IRS Form SS-4.



              </div>
              <div class="row mt-2">
                Assists with completion and filing of IRS Form 2678 appointing &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS as the agent
                responsible for filing federal taxes for the employer. &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS is responsible for tax
              </div>
              <div class="row mt-2">
                obligations from the service start until approval of agent status is received.
                Obtains a MN Tax ID for the employer with completion and filing of the Application for Business
                Registration.
              </div>
              <div class="row mt-2">
                Assists in the completion and filing of MN Rev 184 which appoints &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS limited power
                of attorney for the purpose of state withholding tax.
              </div>
              <div class="row mt-2">
                Acts as the employer’s Unemployment Insurance (UI) agent, establishes an account when
                needed, represents the employer in UI matters and receives related mailings.



              </div>
              <div class="row mt-2">
                Obtains a Workers’ Compensation policy for the employer if needed. If the employer has their
                own policy, a copy must be provided before employees start work and when the policy renews.
              </div>
              <div class="row mt-2">
                Maintains and processes employee applications including background checks, fingerprint
                authorizations, Unique MN Provider Identifier applications, W-4s, I-9s, pay notices and
                relationship disclosures.
              </div>
              <div class="row mt-2">
                Reports new hires to MN for child support obligations, processes worker garnishments in
                accordance with federal and state laws and deducts union dues if required.
              </div>
              <div class="row mt-2">
                Provides Employer and Employee Handbooks that include information on federal and state
                laws, resources, and policies for Mandated Reporting, Fraud and HIPAA.



              </div>
              <div class="row mt-2">
                Makes payment authorized in the plan in accordance with approved time entries and federal
                and state labor laws such as the Fair Labor Standards Act.
              </div>
              <div class="row mt-2">
                Calculates and deposits employer and employee payroll taxes, issues W-2s and refunds over
                collected FICA.
              </div>
              <div class="row mt-2">
                Provide vendor packets with W-9s, pays service vendors and issues 1099s.
              </div>
              <div class="row mt-2">
                Assists with orders and processes reimbursements Friday if the request is received Tuesday.


              </div>
              <div class="row mt-2">
                Sets up a budget based on the participant’s approved plan and tracks changes.
              </div>
              <div class="row mt-2">
                Makes monthly reports available showing budgeted and spent funds and reports overspending
                (>15%), underspending (>15%) and unapproved overtime. </div>
              <div class="row mt-2">

                Verifies program eligibility, suspends payment if eligibility has lapsed, and bills for
                services.
              </div>
              <div class="row mt-4">
                <h3><b>Participant/Representative Roles and Responsibilities</b></h3>
              </div>
              <div class="row mt-2">
                The employer recruits, hires, trains, supervises, and terminates employees.



              </div>
              <div class="row mt-2">
                Employees cannot be scheduled before &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS has notified the employer an
                employee
                can start. If an employee works before their start date, they will not be paid by &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS.
              </div>
              <div class="row mt-2">
                The employer will not discriminate against employees or applicants because of race, religion,
                national origin, sex (including pregnancy, sexual orientation, or gender identification),
                disability,
                age or any other status protected by law.
              </div>
              <div class="row mt-2">
                The employer maintains employee files with job descriptions, evaluations and records of
                tardiness, absenteeism, or termination if needed. The employer notifies &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; if an
                employee is ineligible for unemployment with documentation of employee performance.
              </div>
              <div class="row mt-2">
                The employer determines employee pay rates and benefits in compliance with program rules,
                the collective bargaining agreement, and local ordinances. Wage changes are communicated to


              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS in writing, in addition
                to being listed in the plan.
                Parents of minors and spouses are unable to work over 40 hours a week. Hours above 40 hours
                are considered unpaid natural supports.
              </div>
              <div class="row mt-2">
                If minors, 14 to 17 years old, are employed, minor labor laws must be followed.

              </div>
              <div class="row mt-2">
                Overtime is unapproved unless documented by the lead agency. Overtime occurs when an
                employee works more than 40 hours a week. If submitted, it is paid at 1.5 times the rate of pay.
              </div>
              <div class="row mt-2">
                The employer and employee submit time and are responsible for the accuracy of the hours. Pay
                dates are listed in the Payroll Calendar. Pay statements are available through CYMA. Hours



              </div>
              <div class="row mt-2">
                worked should be submitted by deadlines and no later than 30 days from the service date.
                The participant understands employees are mandated reporters under the Vulnerable Adult
                and Maltreatment of Minors Reporting Act. &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; staff are also mandated reporters.
              </div>
              <div class="row mt-2">
                The participant will report fraud to &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;, the lead agency or DHS.
              </div>
              <div class="row mt-2">
                The participant will notify &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp;
                of admission to a care facility such as a hospital, group
                home, assisted living or nursing home. Employees cannot work during this time.
              </div>
              <div class="row mt-2">
                Participants with a patient responsibility must pay their spenddown or responsibility by the
                listed date. If patient responsibilities are not met, services may be suspended.



              </div>
              <div class="row mt-2">
                The participant completes necessary paperwork to maintain program eligibility.
              </div>
              <div class="row mt-2">
                The participant reviews spending reports to make sure information is accurate and adjusts
                spending if the budget is overspent.
              </div>
              <div class="row mt-2">
                The participant pays for goods, services or hours worked beyond budgeted funds.
              </div>
              <div class="row mt-4">
                <h3><b>Customer Service and Grievances</b></h3>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; strives to return calls and
                emails within a business day and provide responsive and
                respectful customer service. Grievances can be submitted online, by email or mail in the event
                there is an issue, and it is not resolved through communication with the &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS
                Coordinator. Grievances are investigated and resolved within 30 days. If the issue cannot be
                resolved within 30 days, the reason for the delay will be explained in writing
              </div>
              <div class="row mt-4">
                <h3><b>Termination</b></h3>
              </div>
              <div class="row mt-2">
                Either party may terminate this agreement. Once terminated, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS will revoke any
                agent appointments and close out Workers’ Compensation if obtained by &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS. When
                transferring to a different CFSS provider, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS will work with the new provider
                to
                coordinate necessary information for tax filings and continuity of care.
              </div>
              <div class="row mt-2">
                <h3><b>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; Terminates CFSS</b>
                </h3>
              </div>

              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS will provide written
                notice to the participant at least 10 days before the
                proposed service termination date unless DHS grants an exception. Exceptions include:
                <ul style="margin-left:30px">
                  <li>A hostile relationship characterized by lack of collaboration and
                    communication.

                  </li>
                  <li>Conduct resulting in a report being made to the Office of Inspector General
                    (OIG) or the Surveillance & Integrity Review Section (SIRS).</li>
                </ul>

              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS must send written
                notice to the participant and lead agency. The notice will
                include the effective date and reason for termination.

              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS can terminate services
                without cause, if the participant is given written notice
                at
                the payment of a quarter end and at least 30 days before termination.
              </div>
              <div class="row mt-2">
                <h3><b>Participant Terminates CFSS</b></h3>
              </div>
              <div class="row mt-2">
                When a Participant initiates a request to terminate services, &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS will respond with
                written acknowledgement within 5 business days. The acknowledgement will include the date
                the request was received, the requested termination date and the actual termination date
                services will occur if the requested date cannot be accommodated.
              </div>
              <div class="row mt-4">
                <h3><b>Agent Authorization</b></h3>
              </div>
              <div class="row mt-2">
                &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS is authorized:
                <ul style="margin-left:30px">
                  <li>To act as third-party designee for IRS Form SS-4 and obtain an EIN.


                  </li>
                  <li>To file Forms 2678 and Rev 184 for employer tax reporting.</li>
                  <li>To act as Unemployment Agent: apply for an account, fulfill employer
                    responsibilities (tax, benefits and appeals) and receive related documents.</li>
                  <li>To obtain Workers’ Compensation if a policy is needed. </li>

                </ul>
              </div>

              <div class="row mt-2">
                The authorization remains in effect until &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; no longer acts as Fiscal/Employer
                Agent.
              </div>

              <div class="row mt-4">
                <h3><b>Signatures and Effective Date </b></h3>
              </div>
              <div class="row mt-2">
                This Agreement is effective&nbsp;
                <my-date-picker style="width:150px;display: inline-block;"
                 [options]="myDatePickerOptionsDOB"
                  [selDate]="OnboardClientDocumentBO.participantAgreementTemplateBO.effectivedate"
                  placeholder="mm/dd/yyyy" [disabled]="global.OnboardingLoginType !='onboardLogin'"
                  (inputFieldChanged)="newdates($event,'inputchange','effdate')"
                  (dateChanged)="newdates($event,'datechanged','effdate')">
                </my-date-picker>
                (date) between &nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS and the
                participant
                employer and/or their representative&nbsp;
                <input type="text" style="width:120px;display: inline-block;" disabled class="form-control">
                (print name). By signing, the
                parties agree to the terms within; have reviewed and understand roles and responsibilities; and
                a Handbook has been provided with Mandated Reporting, HIPAA, Fraud and Grievance Policies.
              </div>

              <div class="row mt-4">
                <div class="col-6">
                  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Participant2"
                    disabled> Participant/Representative Signature:
                  </button>
                </div>
                <div class="col-lg-1">
                  <label for="cname">Date: </label>
                </div>
                <div class="col-lg-3">
                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                    [disabled]="ClientTemplateBO?.datalist?.documentType!=null" placeholder="mm/dd/yyyy">

                  </my-date-picker>
                </div>
              </div>



              <div class="row mt-2 mb-2">

                <div class="col-lg-4">
                  <input *ngIf="pantsign!=''&& pantsign!=null" type="image" src="{{pantsign}}" class="form-control"
                    style="width: 255px;height:120px;" alt="nurse" width="48" height="48" />
                </div>
              </div>
              <div class="row mt-2">

              </div>


            </div>
            <!-- <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" (click)="save()"
                    class="btn blue-btn">Save</button>
                  
                  <button type="button" class="btn blue-btn ms-3" data-bs-dismiss="modal" (click)="clearparticipantbo()"
                    >Clear</button>
                </div>

              </div>
            </div> -->

          </div>
        </div>
      </div>


      <div class="row mb-4 mt-4">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:85px;">

              <div class="row mt-3">
                <h3><b>Release of Information
                  </b></h3>
              </div>
              <div class="row mt-4">
                <div class="col-lg-2">
                  <div class="row">
                    <label>Participant Name</label>
                  </div>

                </div>
                <div class="col-lg-4">
                  <input type="text" class="form-control" disabled>
                </div>
              </div>
              <div class="row mt-3">
                <p>I authorize the release of my records /information between &nbsp; <b
                    style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; and the following</p>
                <ul style="margin-left:30px">
                  <li>Lead agency</li>
                  <li>Support planner</li>
                  <li>Plan vendors</li>
                  <li>CFSS (if transferring from an CFSS to obtain employer IDs, accounts and
                    spending reports to coordinate tax filing and program delivery)</li>
                  <li>
                    Other&nbsp;
                    <input type="text" class="form-control mb-2"
                      [(ngModel)]="OnboardClientDocumentBO.release_of_InformationTemplateBO.others"
                      style="width: 180px;display: inline-block;">
                    &nbsp;
                  </li>
                </ul>
              </div>



              <div class="row mt-1">
                <div class="col-lg-10 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <label class="col-lg-8">I authorize &nbsp; <b
                      style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; to send unsecured communication
                    containing protected
                    health
                    information (PHI) by email:</label>
                  &nbsp;&nbsp;

                  <label>yes</label>&nbsp;

                  <div class="col-lg-1">
                    <input type="radio" name="email" value="true"  [(ngModel)]="OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare">
                  </div>

                  <label>
                    no
                  </label>&nbsp;

                  <div class="col-lg-1">
                    <input type="radio"  name="email" value="false"  [(ngModel)]="OnboardClientDocumentBO.release_of_InformationTemplateBO.authorizeBestCare">

                  </div>
                </div>



              </div>

              <div class="row mt-2">
                I have been informed of the risks of transmitting PHI by unsecured means which include:
                <ul style="margin-left:30px;">
                  <li>Email that includes PHI will not be encrypted.</li>
                  <li>Unsecured email may not prevent others from accessing content.</li>
                  <li>Sending unsecured PHI exposes it to others who may use it maliciously.</li>
                  <li>&nbsp; <b style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; has no control over
                    email access sent unsecured from our server.</li>

                </ul>
              </div>
              <div class="row mt-2">
                The authorization is valid for one year from the signature date unless specified. I may end the
                authorization by written request any time by contacting the &nbsp; <b
                  style="display: inline-block">{{this.global.agencyName}}</b>&nbsp; CFSS.
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Participant3"
                    disabled> Signature:
                  </button>

                </div>
                <div class="col-lg-1">
                  <label for="cname">Date:
                  </label>
                </div>
                <div class="col-lg-3">
                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                    [disabled]="ClientTemplateBO?.datalist?.documentType!=null" placeholder="mm/dd/yyyy"></my-date-picker>
                </div>
              </div>
              <div class="row mt-2 mb-2">

                <div class="col-lg-4">
                  <input *ngIf="pantsign1!=''&& pantsign1!=null " type="image" src="{{pantsign1}}" class="form-control"
                    style="width: 255px;height:120px;" alt="nurse" width="48" height="48">
                </div>
              </div>


            </div>
            <!-- <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" (click)="save()" class="btn blue-btn"
                  >Save</button>
                
                  <button type="button" class="btn blue-btn ms-3" data-bs-dismiss="modal" (click)="clearreleasebo()"
                   >Clear</button>
                </div>

              </div>
            </div> -->

          </div>
        </div>
      </div>


      <div class="row mb-4 mt-4">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">

              <div class="row">
                <div class="col-lg-2">
                  <h5>Form<h3><b>SS-4</b></h3>
                  </h5>
                  <p>(Rev. December 2019)</p>
                  <p>Department of the Treasury
                    Internal Revenue Service </p>
                </div>
                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-lg-12">
                      <h4><b>Application for Employer Identification Number</b></h4>
                      <p><b>(For use by employers, corporations, partnerships, trusts, estates, churches,
                          government agencies, Indian tribal entities, certain individuals, and others.)</b></p>
                      <p>
                        <b>
                          ▶ Go to www.irs.gov/FormSS4 for instructions and the latest information
                        </b>
                      </p>
                      <p><b>
                          ▶ See separate instructions for each line.&nbsp;&nbsp; ▶ Keep a copy for your records
                        </b></p>

                    </div>
                  </div>

                </div>
                <div class="col-lg-2">
                  <p>OMB No. 1545-0003</p>
                  <label>EIN </label>
                  <input type="text" class="form-control" disabled>

                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6">
                  <label>1&nbsp;&nbsp;Legal name of entity (or individual) for whom the EIN is being requested
                  </label>
                  <input type="text" class="form-control" disabled>
                </div>

              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>2&nbsp;&nbsp;Trade name of business (if different from name on line 1)
                  </label>
                  <input type="text" class="form-control" disabled>
                </div>
                <div class="col-5">
                  <label>3&nbsp;&nbsp; Executor, administrator, trustee, “care of” name
                  </label>
                  <input type="text" class="form-control" disabled [(ngModel)]="prepolate.adminstrartor">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>4a&nbsp;&nbsp;Mailing address(room, apt., suite no. and street)
                  </label>
                  <textarea class="form-control" disabled  [(ngModel)]="prepolate.mail"></textarea>
                </div>
                <div class="col-5">
                  <label>4b&nbsp;&nbsp;Street address(if Different)(Don’t enter a P.O. box)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.agencyCity_state_zipIdifferent1"></textarea>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>5a&nbsp;&nbsp;City, state, and ZIP code (if foreign, see instructions)
                  </label>
                  <textarea class="form-control" disabled [(ngModel)]="prepolate.city"></textarea>
                </div>
                <div class="col-5">
                  <label>5b&nbsp;&nbsp;City, state, and ZIP code (if foreign, see instructions)
                  </label>
                  <textarea class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.agencyCity_state_zipIdifferent"></textarea>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-10">
                  <label>6&nbsp;&nbsp;County and state where principal business is located
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.agencyCounty">
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-5">
                  <label>7a&nbsp;&nbsp; Name of responsible party
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.nameofResponsibleParty">
                </div>
                <div class="col-5" [formGroup]="form">
                  <label>7b&nbsp;&nbsp;SSN, ITIN, or EIN
                  </label>
                  <input type="text" class="form-control" formControlName="Identificationssn"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.ssn"
                    minlength="9" maxlength="9" (keypress)="keyPress($event)">
                  <span class="req" *ngIf="form.controls['Identificationssn'].invalid">

                    <p>*Enter Valid SSN, Enter 9 digit</p>
                  </span>

                </div>





              </div>

              <div class="row mt-2">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <div class="row">
                    <div class="col-lg-8">
                      <label>8a Is this application for a limited liability company (LLC) (or a foreign equivalent)? . .
                        .
                        . . . . .
                      </label>
                    </div>
                    <div class="col-lg-2">
                      <label>yes</label>
                      <input type="radio" name="llc"  value="true" [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc">
                    </div>
                    <div class="col-lg-2">
                      <label>no</label>
                      <input type="radio" name="llc"   value="false" [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicationLlc">

                    </div>

                  </div>



                </div>
                <div class="col-5">
                  <label>8b&nbsp;&nbsp;If 8a is “Yes,” enter the number of
                    LLC members . . . . .
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.ifYesnumberofLlcMembers">
                </div>


              </div>




              <div class="row mt-1">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-8">
                      <label>8c&nbsp;&nbsp;If 8a is “Yes,” was the LLC organized in the United States?
                      </label>
                    </div>
                    <div class="col-lg-2">
                      <label>yes</label>
                      <input type="radio" name="United"  value="true"  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates">
                    </div>
                    <div class="col-lg-2">
                      <label>no</label>
                      <input type="radio" name="United"   value="false"  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isllc_Organized_UnitedStates">

                    </div>

                  </div>

                </div>



              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row mt-2">
                        <div class="col-8">

                          <label>9a&nbsp;&nbsp;Type of entity (check only one box). Caution:</label><label>If 8a is
                            “Yes,” see the instructions for the correct box to check.
                          </label>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-1">
                              <input type="radio" name="entity1" value="one" (click)="radio1()"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Sole proprietor (SSN)
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool1"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.solepropritor_Ssn"
                                minlength="9" maxlength="9">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity2" (click)="event()" value="two"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Partnership
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity3" value="three"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio2()">
                            </div>
                            <div class="col-lg-6">
                              <label> Corporation (enter form number to be filed) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool2"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.corporationNumber">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity4" (click)="event()" value="four"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Personal service corporation
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity5" value="five"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-6">
                              <label>Church or church-controlled organization
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity6" value="six"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio3()">
                            </div>
                            <div class="col-lg-6">
                              <label> Other nonprofit organization (specify) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool3"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.otherNonProfitOrgText">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity7" value="seven"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio4()">
                            </div>
                            <div class="col-lg-6">
                              <label> Other (specify) ▶ </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool4"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_9aText">
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity8" value="eight"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio5()">
                            </div>
                            <div class="col-lg-6">
                              <label>Estate (SSN of decedent)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool5"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.estate_Ssn"
                                minlength="9" maxlength="9">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity9" value="nine"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio6()">
                            </div>
                            <div class="col-lg-6">
                              <label>Plan administrator (TIN)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool6"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.planAdministrator_Tin">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity0" value="ten"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio7()">
                            </div>
                            <div class="col-lg-6">
                              <label>Trust (TIN of grantor)</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!ssnbool7"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.trust_Tin">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity11" (click)="event()" value="eleven"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Military/National Guard </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" name="entity12" (click)="event()" value="tweleve"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label> State/local government</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity13" value="thirdteen"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Farmers’ cooperative</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity14" value="fourteen"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label> Federal government</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity15" value="fifteen"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>REMIC </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="event()" name="entity16" value="sixteen"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity">
                            </div>
                            <div class="col-lg-5">
                              <label>Indian tribal governments/enterprises</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" name="entity17" value="seventeen"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.typeofEntity"
                                (click)="radio8()">
                            </div>
                            <div class="col-lg-6">
                              <label>Group Exemption Number (GEN) if any ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.genIfAny"
                                [disabled]="!ssnbool8">
                            </div>
                          </div>

                        </div>





                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3">
                  <p>9b&nbsp;&nbsp; If a corporation, name the state or foreign country (if
                    applicable) where incorporated</p>
                </div>
                <div class="col-3">
                  <label>State
                  </label>
                  <ng-select
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.state_9b"
                    [items]="stateList" class="width25" [searchable]="true" [clearable]="true" bindLabel="name"
                    bindValue="abbreviation"></ng-select>
                </div>
                <div class="col-3">
                  <label>Foreign country
                  </label>
                  <input type="text" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.foreignCountry">
                </div>
              </div>


              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">

                        <div class="col-8">

                          <label>10&nbsp;&nbsp;Reason for applying (check only one box)
                          </label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange1($event)" name="business1" value="a"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="1">
                            </div>
                            <div class="col-lg-6">
                              <label>Started new business (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool1"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.startedNewbusinessSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radioevent()" name="business2" value="b"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="2">
                            </div>
                            <div class="col-lg-6">
                              <label>Hired employees (Check the box and see line 13.)
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radioevent()" name="business3" value="c"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="3">

                            </div>
                            <div class="col-lg-6">
                              <label>Compliance with IRS withholding regulations
                              </label>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange2($event)" name="business4" value="d"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="4">

                            </div>
                            <div class="col-lg-6">
                              <label>Other (specify) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool2"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.other_10_specify">

                            </div>
                          </div>

                        </div>
                        <div class="col-lg-6">

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange3($event)" name="business5" value="f"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="6">
                            </div>
                            <div class="col-lg-6">
                              <label>Banking purpose (specify purpose) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool3"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.backingPurposeSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange4($event)" name="business6" value="g"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="7">
                            </div>
                            <div class="col-lg-6">
                              <label>Changed type of organization (specify new type) ▶</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool4"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.changedTypeOrgType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange5($event)" name="business7" value="h"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="8">
                            </div>
                            <div class="col-lg-6">
                              <label>Purchased going business</label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool5"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.purchaseedGoingBusinesstext">
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange6($event)" name="business8" value="i"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="9">
                            </div>
                            <div class="col-lg-6">
                              <label>Created a trust (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool6"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdTrustSpecifyType">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="radiochange7($event)" name="business9" value="j"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.reasonForAppling"
                                id="10">
                            </div>
                            <div class="col-lg-6">
                              <label>Created a pension plan (specify type) ▶
                              </label>
                            </div>
                            <div class="col-3">
                              <input type="text" class="form-control" [disabled]="!snbool7"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.createdPensionPlanSpecifyType">
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>






              <div class="row mt-2">

                <div class="col-5">
                  <label>11&nbsp;&nbsp;Date business started or acquired (month, day, year). See instructions
                  </label>

                  <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                    [selDate]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.dateofBusinessStarted"
                    (inputFieldChanged)="newdates($event,'inputchange','business')"
                    (dateChanged)="newdates($event,'datechanged','business')"
                    [disabled]="global.OnboardingLoginType !='onboardLogin'">

                  </my-date-picker>
                </div>
                <div class="col-5">
                  <label>12&nbsp;&nbsp;Closing month of accounting year
                  </label>

                  <input type="string" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.closingMonth">



                </div>
              </div>
              <div class="row mt-2">

                <div class="col-6">
                  <p>13&nbsp;&nbsp;Highest number of employees expected in the next 12 months (enter -0- if
                    none). If no employees expected, skip line 14.</p>
                  <div class="row">
                    <div class="col-3">
                      <label>Agricultural
                      </label>
                      <input type="text" class="form-control"
                        [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.no_of_employees_Agriculture">
                    </div>
                    <div class="col-3">
                      <label>Household
                      </label>
                      <input type="text" class="form-control"
                        [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.no_of_employees_HouseHold">
                    </div>
                    <div class="col-3">
                      <label>Other
                      </label>
                      <input type="text" class="form-control"
                        [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.no_of_employees_other">
                    </div>
                  </div>


                </div>
                <div class="col-6">
                  <div class="col-lg-10">
                    <p>14&nbsp;&nbsp;
                      If you expect your employment tax liability to be $1,000 or
                      less in a full calendar year and want to file Form 944
                      annually instead of Forms 941 quarterly, check here.
                      (Your employment tax liability generally will be $1,000
                      or less if you expect to pay $5,000 or less in total wages.)
                      If you don’t check this box, you must file Form 941 for
                      every quarter&nbsp;<input type="checkbox"
                        [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.file_Form_941_every_quarter">
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-8">
                  <p>15&nbsp;&nbsp;
                    First date wages or annuities were paid (month, day, year). Note: If applicant is a withholding
                    agent, enter date income will first be paid to
                    nonresident alien (month, day, year) . . . . . . . . . . . ▶
                    <my-date-picker class="w-100" 
                    style="display:inline-block;width:150px;"
                      [options]="myDatePickerOptionsDOB"
                       placeholder="mm/dd/yyyy"
                      [selDate]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.first_date_wages_Annuities_were_paid"
                      (inputFieldChanged)="newdates($event,'inputchange','alien')"
                      (dateChanged)="newdates($event,'datechanged','alien')"
                      [disabled]="global.OnboardingLoginType !='onboardLogin'">

                    </my-date-picker>

                  </p>

                </div>

              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-6">
                          <p>16&nbsp;&nbsp;Check one box that best describes the principal activity of your
                            business.</p>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="q"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="aa" name="principal1">
                            </div>
                            <div class="col-lg-3">
                              <label>Construction </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="r"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="bb" name="principal2">
                            </div>
                            <div class="col-lg-3">
                              <label>Rental & leasing </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="s"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="cc" name="principal3">
                            </div>
                            <div class="col-lg-3">
                              <label>Transportation & warehousing</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="t"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="dd" name="principal4">
                            </div>
                            <div class="col-lg-3">
                              <label>Real estate</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="u"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="ee" name="principal5">
                            </div>
                            <div class="col-lg-3">
                              <label>Manufacturing </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="v"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="ff" name="principal6">
                            </div>
                            <div class="col-lg-3">
                              <label>Finance &
                                insurance</label>
                            </div>

                          </div>
                        </div>
                        <div class="col-6">
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="k"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="gg" name="principal7">
                            </div>
                            <div class="col-lg-3">
                              <label> Health care & social assistance </label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="l"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="hh" name="principal8">
                            </div>
                            <div class="col-lg-3">
                              <label>Wholesale-agent/broker </label>
                            </div>

                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="m"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="ii" name="principal9">
                            </div>
                            <div class="col-lg-3">
                              <label>Accommodation & food service</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="n"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="jj" name="principal0">
                            </div>
                            <div class="col-lg-3">
                              <label> Wholesale-other</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="radio" (click)="changeevent()" value="o"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="kk" name="principal11">
                            </div>
                            <div class="col-lg-3">
                              <label> Retail </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="radio" value="p"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.pricipalActivities"
                                id="ll" name="principal22" (ngModelChange)="otherchange($event)">
                            </div>
                            <div class="col-lg-3">
                              <label>Other (specify) ▶</label>
                            </div>
                            <div class="col-lg-3">
                              <input type="text" [disabled]="!otherbool" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.othertext_16">
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-8">
                  <p> 17&nbsp;&nbsp;Indicate principal line of merchandise sold, specific construction work done,
                    products produced, or services provided.<input type="text" class="form-control "
                      [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.indicate_Principle_line"
                      style="display:inline-block;width:150px;"></p>

                </div>

              </div>

              <div class="row mt-1">
                <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 aligned_form">
                  <p>18&nbsp;&nbsp;Has the applicant entity shown on line 1 ever applied for and received an
                    EIN? Yes No
                    If “Yes,” write previous EIN here ▶.<input type="text"
                      [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicant_entity_shown_line1_everapplied_for_and_received_an_EIN_if_yes"
                      class="form-control " style="display:inline-block;width:150px;">
                  </p>&nbsp;&nbsp;
                  <!-- <div class="ms-2" *ngFor="let i of staffingList">
                    <input type="radio" [value]="i.Key"
                      
                      [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicant_entity_shown_line1_everapplied_for_and_received_an_EIN"
                      name="EIN" >
                    {{i.Value}}
                  </div> -->
                  <div class="col-lg-2">
                    <label>Yes</label>
                    <input type="radio"  name="ein1"  value="true"  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein">
                  </div>
                  <div class="col-lg-2">
                    <label>No</label>
                    <input type="radio"  name="ein1"   value="false"  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein">
                  </div>
                </div>



              </div>


              <div class="row mt-2 mb-2">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5>Complete this section only if you want to authorize the named individual to receive the
                        entity’s EIN and answer questions about the completion of this form.</h5>
                    </div>
                    <div class="card-body" style="padding:45px;">

                      <div class="row">
                        <div class="col-2">
                          <div class="row">
                            <div class="col">
                              <div class="card">
                                <div class="card-body">
                                  <h4><b>Third
                                      Party
                                      Designee</b></h4>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>


                        <div class="col-5">
                          <label>Designee’s name </label>

                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designeesName">
                          <label>Address and ZIP code
                          </label>
                          <textarea class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_Address_ZipCode"></textarea>
                        </div>
                        <div class="col-5" [formGroup]="form">
                          <label>Designee’s telephone number (include area code)</label>

                          <input type="text" (keypress)="keyPress($event)" class="form-control"
                            formControlName="Designetele"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_telephone_number"
                            (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                            (keypress)="keyPress($event)">
                          <span class="req" *ngIf="form.controls['Designetele'].invalid">

                            <p>*Enter Valid phone, Enter 10 digit</p>
                          </span>
                          <label>Designee’s fax number (include area code)</label>
                          <input type="text" class="form-control" formControlName="Designefax"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.designees_Fax_Number"
                            (keypress)="keyPress($event)" (ngModelChange)="DemographicPhoneFormat();" minlength="14"
                            maxlength="14" (keypress)="keyPress($event)">

                          <span class="req" *ngIf="form.controls['Designefax'].invalid">

                            <p>*Enter Valid fax, Enter 10 digit</p>
                          </span>
                        </div>

                      </div>

                      <div class="row mt-2">
                        <div class="col-7">
                          <div class="row">
                            <div class="col-12">
                              <p>Under penalties of perjury, I declare that I have examined this application, and to
                                the best of my knowledge and belief, it is true, correct, and complete.
                                Name and title (type or print clearly) ▶<input type="text"
                                  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.under_penalties_of_perjury_Name_title"
                                  class="form-control " style="display:inline-block;width:150px;">
                                <ng-select [items]="selflist" class="width25" [searchable]="true"
                                  style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                  bindValue="Key" placeholder="Choose One"
                                  [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.under_penalties_of_perjury_Name_titleLid">
                                </ng-select>
                              </p>

                            </div>
                          </div>
                        </div>
                        <div class="col-5" [formGroup]="form">

                          <label>Applicant’s telephone number (include area code)</label>
                          <input type="text" (keypress)="keyPress($event)" class="form-control"
                            formControlName="applitele"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Telephone_Number"
                            (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14">


                          <span class="req" *ngIf="form.controls['applitele'].invalid">

                            <p>*Enter Valid phone, Enter 10 digit</p>
                          </span>

                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-7">

                          <div class="row mt-4 ms-2">
                            <div class="col-5">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#user" disabled> Signature
                              </button>
                            </div>
                            <div class="col-lg-2">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-4">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                 placeholder="mm/dd/yyyy" [disabled]="global.OnboardingLoginType !='onboardLogin'"
                                [selDate]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.date"
                                (inputFieldChanged)="newdates($event,'inputchange','appdate')"
                                (dateChanged)="newdates($event,'datechanged','appdate')">

                              </my-date-picker>
                            </div>
                          </div>





                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signature!=''&& signature!=null " type="image" src="{{signature}}"
                                [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.signature"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>


                        </div>
                        <div class="col-5" [formGroup]="form">
                          <label>Applicant’s fax number (include area code)</label>
                          <input type="text" class="form-control" formControlName="applifax"
                            [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberTemplateBO.applicants_Fax_Number"
                            (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                            (keypress)="keyPress($event)">

                          <span class="req" *ngIf="form.controls['applifax'].invalid">

                            <p>*Enter Valid fax, Enter 10 digit</p>
                          </span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>


              <!-- <div class="row mt-4">
                <div class="col" style="text-align: center;">
                  <h4><b>Do I Need an EIN?</b></h4>
                </div>
                
              </div>
                    
              
                    <div class="row mt-2">
                      <p>File Form SS-4 if the applicant entity doesn’t already have an EIN but is required to show an EIN on any return, statement,
                        or other document.1 See also the separate instructions for each line on Form SS-4</p>
                    </div>
                        
                    
                    <div class="row mt-2">
                      <table class="table-bordered table-responsive">
                        <tr>
                          
                          <th style="width:20%;"> IF the applicant...</th>
                          <th style="width: 20%;">AND...</th> 
                          <th style="width: 20%;">THEN...</th> 
                          
                        </tr>
                        <tr>
                          <td>started a new business</td>
                          <td>doesn’t currently have (nor expect to have)
                            employees</td>
                          <td>complete lines 1, 2, 4a–8a, 8b–c (if applicable), 9a,
                            9b (if applicable), and 10–14 and 16–18.
                            </td>
                        
                        </tr>
                        <tr>
                          <td>hired (or will hire) employees,
                            including household employees
                            </td>
                          <td>doesn’t already have an EIN</td>
                          <td>complete lines 1, 2, 4a–6, 7a–b, 8a,
                            8b–c (if applicable), 9a, 9b (if applicable), 10–18.</td>
                        </tr>
                        <tr>
                          <td>opened a bank account </td>
                          <td>needs an EIN for banking purposes only</td>
                          <td>complete lines 1–5b, 7a–b, 8a, 8b–c
                            (if applicable), 9a, 9b (if applicable), 10, and 18.</td>
                        
                        </tr>
                        <tr>
                          <td>changed type of organization</td>
                          <td>either the legal character of the organization or its
                            ownership changed (for example, you incorporate a
                            sole proprietorship or form a partnership)2</td>
                          <td>complete lines 1–18 (as applicable)</td>
                        
                        </tr>
                        <tr>
                          <td>purchased a going business</td>
                          <td>doesn’t already have an EIN</td>
                          <td>complete lines 1–18 (as applicable).</td>
                        
                        </tr>
                        <tr>
                          <td>created a trust</td>
                          <td>the trust is other than a grantor trust or an IRA
                            trust4</td>
                          <td>complete lines 1–18 (as applicable)</td>
                        
                        </tr>
                        <tr>
                          <td>created a pension plan as a
                            plan administrator5</td>
                          <td>needs an EIN for reporting purposes</td>
                          <td>complete lines 1, 3, 4a–5b, 7a–b, 9a, 10, and 18.</td>
                        
                        </tr>
                        <tr>
                          <td>is a foreign person needing an
                            EIN to comply with IRS
                            withholding regulations</td>
                          <td>needs an EIN to complete a Form W-8 (other than
                            Form W-8ECI), avoid withholding on portfolio assets,
                            or claim tax treaty benefits6</td>
                          <td>complete lines 1–5b, 7a–b (SSN or ITIN as applicable),
                            8a, 8b–c (if applicable), 9a, 9b (if applicable), 10,
                            and 18</td>
                        
                        </tr>
                        <tr>
                          <td>is administering an estate</td>
                          <td>needs an EIN to report estate income on Form 1041</td>
                          <td>complete lines 1–7b, 9a, 10–12, 13–17 (if applicable),
                            and 18.</td>
                        
                        </tr>
                        <tr>
                          <td>is a withholding agent for
                            taxes on nonwage income
                            paid to an alien (that is,
                            individual, corporation, or
                            partnership, etc.)</td>
                          <td>is an agent, broker, fiduciary, manager, tenant, or
                            spouse who is required to file Form 1042, Annual
                            Withholding Tax Return for U.S. Source Income of
                            Foreign Persons</td>
                          <td>complete lines 1, 2, 3 (if applicable), 4a–5b, 7a–b, 8a,
                            8b–c (if applicable), 9a, 9b (if applicable), 10, and 18.</td>
                        
                        </tr>
                        <tr>
                          <td>is a state or local agency</td>
                          <td>serves as a tax reporting agent for public assistance
                            recipients under Rev. Proc. 80-4, 1980-1 C.B. 5817</td>
                          <td>complete lines 1, 2, 4a–5b, 7a–b, 9a, 10, and 18.</td>
                        
                        </tr>
                        <tr>
                          <td>s a single-member LLC (or
                            similar single-member entity)</td>
                          <td>needs an EIN to file Form 8832, Entity Classification
                            Election, for filing employment tax returns and excise
                            tax returns, or for state reporting purposes8, or is a
                            foreign-owned U.S. disregarded entity and needs an
                            EIN to file Form 5472, Information Return of a 25%
                            Foreign-Owned U.S. Corporation or a Foreign
                            Corporation Engaged in a U.S. Trade or Business</td>
                          <td>complete lines 1–18 (as applicable)</td>
                        
                        </tr>
                        <tr>
                          <td>is an S corporation</td>
                          <td>needs an EIN to file Form 2553, Election by a Small
                            Business Corporation9</td>
                          <td>complete lines 1–18 (as applicable)</td>
                        
                        </tr>
                        
                      </table>
                  
                    </div>
                    <div class="row mt-3">
                      <ol type="1">
                        <li> For example, a sole proprietorship or self-employed farmer who establishes a qualified retirement plan, or is required to file excise, employment, alcohol, tobacco, or
                          firearms returns, must have an EIN. A partnership, corporation, REMIC (real estate mortgage investment conduit), nonprofit organization (church, club, etc.), or farmers’
                          cooperative must use an EIN for any tax-related purpose even if the entity doesn’t have employees.</li>
                        <li> However, don’t apply for a new EIN if the existing entity only (a) changed its business name, (b) elected on Form 8832 to change the way it is taxed (or is covered by the
                          default rules), or (c) terminated its partnership status because at least 50% of the total interests in partnership capital and profits were sold or exchanged within a 12-
                          month period. The EIN of the terminated partnership should continue to be used. See Regulations section 301.6109-1(d)(2)(iii). </li>
                        <li>Don’t use the EIN of the prior business unless you became the “owner” of a corporation by acquiring its stock.</li>
                        <li>However, grantor trusts that don’t file using Optional Method 1 and IRA trusts that are required to file Form 990-T, Exempt Organization Business Income Tax Return,
                          must have an EIN. For more information on grantor trusts, see the Instructions for Form 1041. </li>
                        <li> A plan administrator is the person or group of persons specified as the administrator by the instrument under which the plan is operated. </li>
                        <li> Entities applying to be a Qualified Intermediary (QI) need a QI-EIN even if they already have an EIN. See Rev. Proc. 2000-12</li>
                        <li>See also Household employer agent in the instructions. Note: State or local agencies may need an EIN for other reasons, for example, hired employees</li>
                        <li>See Disregarded entities in the instructions for details on completing Form SS-4 for an LLC. 
                        </li>
                        <li>An existing corporation that is electing or revoking S corporation status should use its previously-assigned EIN</li>
                      </ol>
                    </div> -->

            </div>
            <!-- <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" (click)="save()"
                 
                    class="btn blue-btn">Save</button>
                

                  <button type="button" class="btn blue-btn ms-3" data-bs-dismiss="modal" (click)="clearapplicationbo()"
                    >Clear</button>
                </div>

              </div>
            </div> -->
          </div>
        </div>
      </div>


      <div class="row mb-4 mt-4">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">
              <!-- <div style="text-align: center;">
                      <img src="..\assets\img\irs.JPG" class="img-fluid" alt="Responsive image" style="margin-bottom:30px;">
                    </div>
                    
                    <p><b>The form you are looking for begins on the next page of this file.</b> Before viewing it, please see
                      the important update information below.</p>
                      <h3 style="text-align:center;margin-bottom:20px;"><b>New Mailing Addresses</b></h3>
                      <p>Addresses for mailing certain forms have changed since the forms were last published. The new mailing
                        addresses are shown below.</p>
                        <p>Mailing address for <b>Forms 706‐A, 706‐GS(D), 706‐GS(T), 706‐NA, 706‐QDT, 8612, 8725, 8831, 8842, 8892,
                          8924, 8928:</b></p>
                        <div class="row" style="padding-left: 1px;">
                          <img src="..\assets\img\address.JPG" class="img-fluid" alt="Responsive image" style="margin-bottom:10px;">
                
                        </div>
                
                          <p>Mailing address for <b> Forms 2678, 8716, 8822-B, 8832, 8855</b></p>
                          <div>
                            <table class="table-bordered table-responsive">
                              <tr>
                                
                                <th style="width:20%">Taxpayers in the States Below </th>
                                <th style="width:20%">Mail the Form to This Address</th> 
                                
                              </tr>
                              <tr >
                                <td >Connecticut, Delaware, District of Columbia, Georgia,
                                  Illinois, Indiana,Kentucky, Maine, Maryland,
                                  Massachusetts, Michigan, New Hampshire, New Jersey,
                                  New York, North Carolina, Ohio, Pennsylvania, Rhode
                                  Island, South Carolina, Vermont, Virginia, West Virginia,
                                  Wisconsin</td>
                                <td  >Department of the Treasury
                                  Internal Revenue Service Center
                                  Kansas City, MO 64999</td>
                              
                              </tr>
                              <tr>
                                <td >Alabama, Alaska, Arizona, Arkansas, California,
                                  Colorado, Florida, Hawaii, Idaho, Iowa, Kansas,
                                  Louisiana, Minnesota, Mississippi, Missouri, Montana,
                                  Nebraska, Nevada, New Mexico, North Dakota,
                                  Oklahoma, Oregon, South Dakota, Tennessee, Texas,
                                  Utah, Washington, Wyoming</td>
                                <td>Department of the Treasury
                                  Internal Revenue Service Center
                                  Ogden, UT 84201</td>
                                
                              </tr>
                              
                            </table>
                          </div>
                          <div class="row mt-3 ms-1">
                          <p>This update supplements these forms’ instructions. Filers should rely on this update for the changes described,
                which will be incorporated into the next revision of the forms’ instructions.</p></div>
                <div> -->
              <h3>Form <b>2678 Employer/Payer Appointment of Agent</b></h3>
              <div class="row mt-2 ms-1">
                <p>
                  (Rev. August 2014)Department of the Treasury — Internal Revenue Service
                </p>
              </div>
              <div class="row mt-2">
                <div class="col-lg-8">
                  <p>Use this form if you want to request approval to have an agent file returns and make
                    deposits or payments of employment or other withholding taxes or if you want to
                    revoke an existing appointment. </p>
                  <p>• If you are an employer or payer who wants to request approval, complete Parts 1
                    and 2 and sign Part 2. Then give it to the agent. Have the agent complete Part 3 and
                    sign it. </p>
                  <p>
                    Note. This appointment is not effective until we approve your request. See the instructions
                    for filing Form 2678 on page 3.
                  </p>
                  <p>• If you are an employer, payer, or agent who wants to revoke an existing appointment,
                    complete all three parts. In this case, only one signature is required.</p>

                </div>
                <div class="col-lg-4">
                  <div class="row mb-2" style="height:150px">
                    <div class="col">
                      <div class="card ">

                        <div class="card-body">
                          <div>
                            <h5 style="background-color: black;color:white">For IRS Use</h5>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 1:</b>&nbsp;<b>Why you are filing this form...</b></h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <p>(Check one) </p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="radio" value="z"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.appointorRevoke"
                            id="pre1" name="deposit1">

                        </div>
                        <div class="col-lg-8">
                          <label>You want to appoint an agent for tax reporting, depositing, and paying. </label>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="radio" value="x"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.appointorRevoke"
                            id="pre2" name="deposit2">
                        </div>
                        <div class="col-lg-8">
                          <label>You want to revoke an existing appointment. </label>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 2:</b>&nbsp;<b>Employer or Payer Information: Complete this part if you want to
                          appoint an agent or revoke an appointment</b></h5>
                    </div>
                    <div class="card-body" style="padding:35px;">
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>1.&nbsp;Employer identification number (EIN) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" disabled class="form-control">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>2.&nbsp;Employer’s or payer’s name
                            (not your trade name)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" disabled class="form-control">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>3.&nbsp;Trade name (if any) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" disabled class="form-control">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>4.&nbsp;Address </label>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4"> <label>Number </label></div>

                            <div class="col-lg-4"> <label>Street </label></div>

                            <div class="col-lg-4"> <label>Suite or room number</label></div>

                          </div>


                          <textarea class="form-control" disabled ></textarea>
                        </div>

                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4">
                              <label>City</label>
                              <input type="text" disabled class="form-control">
                            </div>
                            <div class="col-lg-4">
                              <label>State</label>
                              <ng-select [items]="stateList" class="width25"   [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation" style="pointer-events: none;" >
                              </ng-select>
                            </div>
                            <div class="col-lg-4" [formGroup]="form1">
                              <label>Zip Code</label>

                              <input type="text" (keypress)="keyPress($event)" minlength="5" maxlength="11"  disabled
                                class="form-control" formControlName="Payerzip1">
                              <span class="req" *ngIf="form1.controls['Payerzip1'].invalid" >

                                <p>*Enter Valid zip,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div style="margin-top: 20px;">
                        <table class="table table-bordered table-responsive">
                          <tr>

                            <th style="width: 40%;"> <b>5.&nbsp;Forms for which you want to appoint an agent or
                                revoke the agent’s
                                appointment to file. </b>(Check all that apply.)</th>
                            <th style="width:10%">For ALL
                              employees/
                              payees/payments</th>
                            <th style="width:10%"> <b>For SOME
                                employees/
                                payees/payments</b></th>


                          </tr>
                          <tr>
                            <td style="text-align:left;">Form 940, 940-PR (Employer's Annual Federal Unemployment
                              (FUTA) Tax Return)*
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.futaForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.futaForSome">
                            </td>
                          </tr>

                          <tr>
                            <td style="text-align: left;">
                              Form 943, 943-PR (Employer’s Annual Federal Tax Return for Agricultural Employees)
                            </td>

                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersQuarterlyFederalTaxForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersQuarterlyFederalTaxForSome">
                            </td>
                          </tr>

                          <tr>
                            <td style="text-align: left;">Form 944, 944(SP) (Employer’s ANNUAL Federal Tax Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersAnnualFederalTaxReturnForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersAnnualFederalTaxReturnForSome">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align:left;">Form 945 (Annual Return of Withheld Federal Income Tax)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.annualReturnofWithheldFederalIncomeTaxForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.annualReturnofWithheldFederalIncomeTaxForSome">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align:left;">Form CT-1 (Employer’s Annual Railroad Retirement Tax
                              Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersAnnualRailroadRetirementTaxReturnForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employersAnnualRailroadRetirementTaxReturnForSome">
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align: left;">Form CT-2 (Employee Representative's Quarterly Railroad
                              Tax Return)
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employeeRepresentativesQuarterlyRailroadTaxReturnForAll">
                            </td>
                            <td style="text-align: center;"><input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.employeeRepresentativesQuarterlyRailroadTaxReturnForSome">
                            </td>
                          </tr>



                        </table>
                      </div>
                      <div class="row mt-3 ms-2">
                        <p>*Generally you cannot appoint an agent to report, deposit, and pay tax reported on Form
                          940, Employer's Annual Federal
                          Unemployment (FUTA) Tax Return, unless you are a home care service recipient.</p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="checkbox"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.ifyou_are_home_care_service_recipient">
                        </div>
                        <div class="col-lg-8">
                          <label>Check here if you are a home care service recipient, and you want to appoint the
                            agent to report, deposit, and pay FUTA
                            tax for you. See the instructions</label>
                        </div>
                      </div>
                      <div class="row mt-2 ms-2">
                        <p>I am authorizing the IRS to disclose otherwise confidential tax information to the agent
                          relating to the authority granted under this
                          appointment, including disclosures required to process Form 2678. The agent may contract
                          with a third party, such as a
                          reporting agent or certified public accountant, to prepare or file the returns covered by
                          this appointment, or to make any required
                          deposits and payments. Such contract may authorize the IRS to disclose confidential tax
                          information of the employer/payer and
                          agent to such third party. If a third party fails to file the returns or make the deposits
                          and payments, the agent and employer/
                          payer remain liable.
                        </p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                          <div class="row mt-5 ms-2">
                            <div class="col-6">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal" disabled
                                data-bs-target="#signid">
                                Sign your
                                name here
                              </button>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signhere1!=''&& signhere1!=null" type="image" src="{{signhere1}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <div class="row mt-5 ms-2">
                            <div class="col-lg-3">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-5">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [disabled]="ClientTemplateBO?.datalist?.documentType" placeholder="mm/dd/yyyy">

                              </my-date-picker>
                            </div>

                          </div>
                        </div>




                        <div class="col-lg-6">
                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Type your name here</label></div>
                            <div class="col-lg-5"><input type="text" class="form-control" disabled>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Choose your title here</label></div>
                            <div class="col-lg-5">
                              <ng-select [items]="selflist" class="width25" [searchable]="true"
                                style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                bindValue="Key" placeholder="Choose One">
                              </ng-select>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-5"><label>Best daytime phone
                              </label></div>
                            <div class="col-lg-5" [formGroup]="form1"> <input type="text" class="form-control" disabled
                                formControlName="Payerphone1" (ngModelChange)="DemographicPhoneFormat();" minlength="14"
                                maxlength="14" (keypress)="keyPress($event)">
                              <span class="req" *ngIf="form1.controls['Payerphone1'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>

                            </div>


                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2 mt-4 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-header">
                      <h5><b>Part 3:</b>&nbsp;<b>Agent Information: If you will be an agent for an employer or
                          payer, or want to revoke an appointment, complete this part</b></h5>
                    </div>
                    <div class="card-body" style="padding:35px;">
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>6.&nbsp;Agent’s employer identification number (EIN)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.agentEmployerIndentificationNumber">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>7.&nbsp;Agent’s name (not trade name)</label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" disabled class="form-control" [(ngModel)]="prepolate.agentname">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>8.&nbsp;Trade name (if any) </label>
                        </div>
                        <div class="col-lg-6">
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.agentTradeName">
                        </div>
                      </div>
                      <div class="row mt-3">

                        <div class="col-lg-6">
                          <label>4.&nbsp;Address </label>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4"> <label>Number </label></div>

                            <div class="col-lg-4"> <label>Street </label></div>

                            <div class="col-lg-4"> <label>Suite or room number</label></div>

                          </div>

                          <textarea class="form-control" [(ngModel)]="prepolate.address" disabled></textarea>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-6">

                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-4">
                              <label>City</label>
                              <input type="text" class="form-control" disabled [(ngModel)]="prepolate.agentcity">
                            </div>
                            <div class="col-lg-4">
                              <label>State</label>
                              <ng-select [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                disabled bindLabel="name" bindValue="abbreviation" [(ngModel)]="prepolate.state">
                              </ng-select>
                            </div>
                            <div class="col-lg-4" [formGroup]="form1">
                              <label>Zip Code</label>
                              <input type="string" (keypress)="keyPress($event)" minlength="5" maxlength="11" disabled
                                class="form-control" formControlName="Payerzip2"  [(ngModel)]="prepolate.zip">
                              <span class="req" *ngIf="form1.controls['Payerzip2'].invalid" >

                                <p>*Enter Valid zip ,Enter 5 to 11 digit</p>
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>





                      <div class="row mt-2">
                        <div class="col-lg-1">
                          <input type="checkbox"
                            [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.ifyou_are_home_care_service_recipient">
                        </div>
                        <div class="col-lg-8">
                          <label>Check here if the employer is a home care service recipient receiving home care
                            services through a program administered by a
                            federal, state, or local government agency</label>
                        </div>
                      </div>
                      <div class="row mt-3 ms-2">
                        <p>Under penalties of perjury, I declare that I have examined this form and any attachments,
                          and to the best of my knowledge and belief, it
                          is true, correct, and complete. </p>
                      </div>

                      <div class="row mt-2">
                        <div class="col-lg-6">

                          <div class="row mt-5 ms-2">
                            <div class="col-6">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal" disabled
                                data-bs-target="#signhere2">
                                Sign your
                                name here
                              </button>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="signhere2!=''&& signhere2!=null " type="image" src="{{signhere2}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <div class="row mt-5 ms-2">
                            <div class="col-lg-3">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-5">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [disabled]="ClientTemplateBO?.datalist?.documentType" placeholder="mm/dd/yyyy">

                              </my-date-picker>
                            </div>

                          </div>
                        </div>




                        <div class="col-lg-6">
                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Type your name here</label></div>
                            <div class="col-lg-5"><input type="text" disabled class="form-control">
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Choose your title here</label></div>
                            <div class="col-lg-5">
                              <ng-select [items]="selflist" class="width25" [searchable]="true"
                                style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                bindValue="Key" placeholder="Choose One"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.titleName">
                              </ng-select>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-lg-3"><label>Best daytime phone
                              </label></div>
                            <div class="col-lg-5" [formGroup]="form1"> <input type="text" class="form-control"
                                formControlName="Payerphone2"
                                [(ngModel)]="OnboardClientDocumentBO.employerOrPayerAppointmentOfAgentTemplateBO.agentDayTimePhone"
                                (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)">
                              <span class="req" *ngIf="form1.controls['Payerphone2'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>
                            </div>


                          </div>


                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>


              <!--                       
                      <div class="row mt-5">
                        <div class="col-lg-6">
                          <h5><b>Instructions for Form 2678</b></h5>
                          <p>Section references are to the Internal Revenue Code. </p>
                          <h5><b>Future Developments</b></h5>
                          <p>For the latest information about developments related to Form
                            2678 and its instructions, such as legislation enacted after they
                            were published, go to www.irs.gov/form2678. </p>
                          <h5><b>Purpose of Form</b></h5>
                          <p>Use Form 2678 if you want to:</p>
                        <p>• Request approval to have an agent file returns and make
                          deposits or payments of Federal Insurance Contributions Act
                          (FICA) taxes, Railroad Retirement Tax Act (RRTA) taxes, income
                          tax withholding (ITW), or backup withholding; or</p>
                          <p>• Revoke an existing appointment.</p>
                          <p>Do not use prior versions of this form. All prior versions are
                            obsolete. IRS will not accept them</p>
                          
                          <h5><b>Can Employers Appoint Agents to Report,
                            Deposit, and Pay Federal Unemployment Tax
                            Act (FUTA) Tax?</b></h5>
                          <p>Generally, employers cannot appoint an agent to report,
                            deposit, and pay FUTA tax. However, if you are an employer
                            who receives home care service, you may ask IRS to approve
                            an agent to act on your behalf for FUTA tax purposes. Check
                            the box in the footnote in Part 2, line 5.   
                          </p>
                          <p>To appoint an agent to act for FUTA tax purposes, you must
                            also appoint the agent to act for FICA taxes and ITW purposes.</p>
                          <h5><b>How to Complete the Form
                            </b></h5>
                          
                        <h5><b>Part 1: Why You Are Filing This Form</b></h5>
                          <p>In Part 1, you will check a box to indicate why you are filing
                            Form 2678
                            </p>
                            <p>• If you are an employer or payer and you want to appoint an
                              agent, check the box that says, “You want to appoint an agent
                              for tax reporting, depositing, and paying.”</p>
                              <p>• If you are an employer, payer, or agent and you want to
                                revoke an existing appointment, check the box that says,
                                “You want to revoke an existing appointment.”</p>
                            
                          <h5><b> Part 2: Employer or Payer Information </b></h5>
                          <p> • If you are an employer or payer, enter your employer
                            identification number (EIN), name, trade name, and address.</p>
                            <p>• If you are an agent revoking an existing appointment, enter the
                              EIN, name, trade name, and address of the employer or payer
                              for whom you have been authorized to act. The employer's or
                              payer's signature is not required.
                              </p>
                              <p>On line 5, check the boxes for all forms for which you want to:</p>
                              <p>• Request approval to appoint an agent to file on your behalf, or</p>
                              <p>• Revoke an agent's existing appointment</p>
                              <p>If you are only appointing an agent for some employees,
                                payees, or payments, check the box under For SOME
                                employees/payees/payments.
                                </p>
                              
                                
                        </div>
                        <div class="col-lg-6">
                          <h5><b>Example 1.</b></h5>
                          <p>You are an employer. You appoint an agent to file
                            returns and deposit FICA taxes and ITW related to biweekly
                            wage payments that you paid your employees. However, you
                            make bonus wage payments directly to your employees, not
                            through the agent. You should report the bonus payments on a
                            return filed using your EIN.</p>
                      
                      
                      
                        <h5><b>Example 2</b></h5>
                          <p>. You are an employer. You appoint an agent to file
                            returns and deposit FICA taxes and ITW for biweekly wage
                            payments that you paid to your employees. However, you make
                            biweekly wage payments directly to your company's executives.
                            You should report the wage payments to the executives on a
                            return filed using your EIN.</p>
                            <p>If you are an employer or payer and you are requesting
                              authorization to appoint an agent, sign and date Form 2678 in
                              Part 2. Then give the form to the agent to complete and sign
                              Part 3.</p>
                              <p>If you are an employer or payer and you want to revoke an
                                existing appointment, sign and date Form 2678 in Part 2.
                                Complete Part 3. Then send the form to the address for your
                                location under Where To File, later.</p>
                            
                      
                            <h5><b>Part 3: Agent Information</b></h5>
                          <p>• If you are an employer or payer and you are requesting
                            authorization to appoint an agent, have the agent complete and
                            sign Part 3.</p>
                            <p>• If you are an employer or payer and you want to revoke an
                              existing appointment, complete Part 3. The agent's signature is
                              not required. Then send the form to the address for your
                              location under Where To File, later.</p>
                              <p>• If you want to accept an appointment as an agent or you are
                                an agent who wants to revoke an existing appointment,
                                complete Part 3 with your information. Then sign and date the
                                form where indicated. Send the form to the address for the
                                employer's or payer's location under Where To File, later. </p>
                                <p><b>Note</b> If an agent is a corporate officer, partner, or tax matters
                                  partner, the agent must have the authority to execute this
                                  appointment of agent.</p>
                      
                          <h5><b>Filing Form 2678</b></h5>
                          <p>Send Form 2678 to the address for the employer's or payer's
                            location under Where To File, later. We will send a letter to the
                            employer or payer and to the agent after we have approved the
                            request. For agents of home care service recipients, we will
                            send the approval letter only to the agent</p>
                            <p><b>The authorization to act as an agent is effective on the date
                              shown in the letter.</b> Until we approve the request, the agent is
                              not liable for filing any tax returns or making any deposits or
                              payments</p>
                              <p>Only one signature is required to revoke an agent's
                                appointment. If an existing appointment is revoked, the IRS
                                cannot disclose confidential tax information to anyone other
                                than the employer or payer for periods after the appointment is
                                revoked.</p>
                                <p>If an agent's appointment is revoked, we will send both the
                                  employer or payer and the agent a letter confirming the
                                  revocation. For agents of home care service recipients, we will
                                  send the letter confirming the revocation only to the agent.<b> The
                                  revocation is effective on the date shown in the letter.</b></p>
                                
                      
                        </div>
                      </div>
              <div class="row mt-3 mb-3">
                <h5><b>Where To File</b></h5>
              </div>
              
                      <div class="row mb-2">
                        <div class="col">
                      <div class="card">
                        <div class="card-header">
                          <div class="row"> <div class="col-lg-8">
                            If you are in...
                          </div>
                          <div class="col-lg-4">
                            Send your form to...
                          </div></div>
                        
                        </div>
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item">
                            <div class="row">
                                <div class="col-lg-5">
                                    <div class="row">
                                        
                                        <div class="col-lg-4">
                                            <ul style="list-style-type:none;">
                                            <li>Connecticut</li>
                                            <li>Delaware</li>
                                            <li>District of</li>
                                            <li>Columbia</li>
                                          </ul> 
                                        </div> 
                                        <div class="col-lg-4">
                                          <ul style="list-style-type:none;">
                                          <li>Florida</li>
                                          <li>Georgia</li>
                                          <li>Illinois</li>
                                          <li>Indiana</li>
                                        </ul> 
                                      </div> 
                                      <div class="col-lg-4">
                                        <ul style="list-style-type:none;">
                                        <li>Kentucky</li>
                                        <li>Maine</li>
                                        <li>Maryland</li>
                                        <li>Massachusetts</li>
                                      </ul> 
                                    </div> 


                                    </div>

                                </div>
                                <div class="col-lg-5">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <ul style="list-style-type:none;">
                                            <li>Michigan</li>
                                            <li> New Hampshire</li>
                                            <li>New Jersey</li>
                                            <li> New York</li>
                                          </ul> 
                                        </div> 
                                        <div class="col-lg-4">
                                          <ul style="list-style-type:none;">
                                          <li>North Carolina
                                          </li>
                                          <li> Ohio</li>
                                          <li>Pennsylvania</li>
                                          <li> Rhode Island</li>
                                        </ul> 
                                      </div> 
                                      <div class="col-lg-4">
                                        <ul style="list-style-type:none;">
                                          <li>South Carolina
                                          </li>
                                          <li> Vermont</li>
                                          <li> Virginia</li>
                                          <li>  West Virginia</li>
                                          <li> Wisconsin</li>
                                      </ul> 
                                    </div> 
                                    </div>

                                </div>
                                <div class="col-lg-2">
                                  
                                        <ul style="list-style-type:none;">
                                          <li>Department of the Treasury
                                          
                                            </li>
                                          <li> Internal Revenue Service</li>
                                          <li>Cincinnati, OH 45999 </li>
                                      </ul> 
                                    

                                </div>
                        
                  

                        </div>
                        </li>
                          <li class="list-group-item">
                            <div class="row">
                                <div class="col-lg-5">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <ul style="list-style-type:none;">
                                              <li>Alabama
                                              </li>
                                              <li> Alaska</li>
                                              <li>Arizona</li>
                                              <li> Arkansas</li>
                                              <li> California</li>
                                          </ul> 
                                        </div> 
                                        <div class="col-lg-4">
                                          <ul style="list-style-type:none;">
                                            <li>Colorado
                                            </li>
                                            <li> Hawaii</li>
                                            <li>  Idaho</li>
                                            <li>  Iowa</li>
                                            <li> Kansas</li>
                                        </ul> 
                                      </div> 
                                    <div class="col-lg-4">
                                      <ul style="list-style-type:none;">
                                        <li>Louisiana
                                        </li>
                                        <li> Minnesota</li>
                                        <li> Mississippi</li>
                                        <li>  Missouri</li>
                                          <li>Montana</li>
                                          
                                        
                                    </ul> 
                                  </div> 
                                    </div>

                                </div>
                                <div class="col-lg-5">
                                    <div class="row">
                                                  
                    <div class="col-lg-4">
                        <ul style="list-style-type:none;">
                          <li>Nebraska</li>
                          <li>Nevada</li>
                          <li>New Mexico</li>
                          <li>North Dakota</li>
                      </ul> 
                    </div> 
                    <div class="col-lg-4">
                      <ul style="list-style-type:none;">
                        <li>Oklahoma
                        
                        
                        </li>
                        <li>  Oregon</li>
                        <li> South Dakota</li>
                        <li> Tennessee</li>
                    </ul> 
                  </div> 
                  <div class="col-lg-4">
                    <ul style="list-style-type:none;">
                      <li>Texas
                    
                      
                      </li>
                      <li>   Utah</li>
                      <li>  Washington</li>
                      <li> Wyoming</li>
                  </ul> 
                  </div> 
                                    </div>
                                    
                                </div>
                                <div class="col-lg-2">
                                  
                                        <ul style="list-style-type:none;">
                                          <li>Department of the Treasury
                                        
                                          </li>
                                          <li>  Internal Revenue Service</li>
                                          <li> Ogden, UT 84201</li>
                                      </ul> 
                                      
                                </div>
                
                
              
                          </div>
              
                          </li>
                          
                          <li class="list-group-item">
                            <div class="row">
                              <div class="col-lg-6">
                                No legal residence or place of business in any state
                              </div>
                              <div class="col-lg-6">
                                Department of the Treasury
              Internal Revenue Service
              Ogden, UT 84201
                              </div>
                            </div>
                          </li>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-lg-6">
                        Exempt organization or government entity
                      </div>
                      <div class="col-lg-6">
                        Department of the Treasury
              Internal Revenue Service
              Ogden, UT 84201-0046
                      </div>
                    </div>
                  </li>
                        </ul>
                      </div>
                      </div>
                      </div>
              
              <div class="row mt-5">
                <div class="col-lg-6">
                  <h5><b>Agent Responsibilities After
                    Appointment</b></h5>
                
                  <h5><b>Reporting, Depositing, and Payment
                    Requirements</b></h5>
                  <p>Agents must follow the procedures for employment taxes in
                    Rev. Proc. 2013-39, 2013-52 I.R.B. 830, available at
                    www.irs.gov/irb/2013-52_IRB/ar15.htms and for backup
                    withholding in Rev. Proc. 84-33. Agents for employers who are
                    home care service recipients receiving home care services
                    through a program administered by a federal, state, or local
                    government agency may also use this form. These agents may
                    be referred to as fiscal/employer agents, household employer
                    agents, and home care service recipient agents.</p>
                    <p>All agents, employers, and payers remain liable for filing all
                      returns and making all tax deposits and payments while this
                      appointment is in effect. If an agent contracts with a third party,
                      such as a reporting agent or certified public accountant, to
                      prepare or file the returns covered by this appointment or to
                      make any required tax deposits or payments and the third party
                      fails to do so, the agent, employer, and payer remain liable.</p>
                  <h5><b>Filing Schedule R (Form 940) and Schedule R
                    (Form 941)</b></h5>
                  <p>An agent for a home care service recipient that files an
                    aggregate Form 940, Employer's Annual Federal Unemployment
                    (FUTA) Tax Return, must complete Schedule R (Form 940),
                    Allocation Schedule for Aggregate Form 940 Filers, and file it
                    with the aggregate Form 940.</p>
                  <P>An agent who files an aggregate Form 941, Employer's
                    QUARTERLY Federal Tax Return, must complete Schedule R
                    (Form 941), Allocation Schedule for Aggregate Form 941 Filers,
                    and file it with the aggregate Form 941.</P>
                    <h5><b>Privacy Act and Paperwork Reduction Act Notice</b></h5>
                    <p> We ask
                      for the information on Form 2678 to carry out the Internal
                      Revenue laws of the United States. The principal purpose of this
                      information is to permit you to appoint an agent to act on your
                      behalf. You do not have to appoint an agent; however, if you
                      choose to appoint an agent, you must provide the information
                      requested on Form 2678. Our authority to collect this
                      information is section 3504. Section 6109 requires you and the
                      agent to provide your identification numbers. Failure to provide
                      this information could delay or prevent processing your
                      appointment of agent. Intentionally providing false information
                      could subject you and the agent to penalties. </p>
                  
                </div>
                <div class="col-lg-6">
                  
                          <p>You are not required to provide the information requested on
                            a form that is subject to the Paperwork Reduction Act unless
                            the form displays a valid OMB control number. Books or
                            records relating to a form or its instructions must be retained as
                            long as their contents may become material in the
                            administration of any Internal Revenue law.</p>
                          <p>Generally, tax returns and return information are confidential,
                            as required by section 6103. However, section 6103 allows or
                            requires the IRS to disclose or give the information shown on
                            this form to others as described in the Code. For example, we
                            may disclose your tax information to the Department of Justice
                            for civil and criminal litigation, and to cities, states, the District of
                            Columbia, and U.S. commonwealths and possessions for use in
                            administering their tax laws. We may also disclose this
                            information to other countries under a tax treaty, to federal and
                            state agencies to enforce federal nontax criminal laws, or to
                            federal law enforcement and intelligence agencies to combat
                            terrorism. </p>
                          <p>The time needed to complete and file Form 2678 will vary
                            depending on individual circumstances. The estimated average
                            time is:</p>
                        
                              <p>
                              <b> Recordkeeping</b> . . . . . . . . . . . 1 hr., 5 min.
                              </p>
                        <p> <b>Learning about the law or the form</b>. . . . . . . 54 min.</p>
                          <p><b>Preparing, copying, assembling, and
                            sending the form to the IRS . . . . . . . . . 13 min</b></p>
                          <p>If you have any comments concerning the accuracy of these
                            time estimates or suggestions for making Form 2678 simpler,
                            we would be happy to hear from you. You can send us
                            comments from www.irs.gov/formspubs. Click on More
                            Information and then click on Give us feedback. Or you can
                            send your comments to Internal Revenue Service, Tax Forms
                            and Publications Division, 1111 Constitution Ave. NW, IR-6526,
                            Washington, DC 20224. Do not send Form 2678 to this
                            address. Instead, see Where To File above</p>
              
                </div>
              </div>
              -->


            </div>
            <!-- <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3" (click)="save()"
                    class="btn blue-btn">Save</button>
                 
                  <button type="button" class="btn blue-btn ms-3" data-bs-dismiss="modal" (click)="clearpayerbo()"
                    >Clear</button>
                </div>

              </div>
            </div> -->
          </div>
        </div>
      </div>



      <div class="row mb-4 mt-4">
        <div class="col">
          <div class="card ">
            <div class="card-body" style="padding:65px;">

              <div class="row mt-2">
                <div class="col-10">
                  <img src="..\assets\img\indivual.JPG" class="img-fluid" alt="Responsive image">
                </div>
              </div>
              <div class="row mt-2 ms-2">
                <p><b>Read Instructions before completing this form.To grant authority for a business,complete form
                    REV184b,Business Power of Attorney</b></p>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\taxpayer.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-11">
                          <div class="row mt-2">
                            <div class="col-6">
                              <label>Taxpayer Name</label>

                              <input type="text" class="form-control" disabled>
                              <label>Street Address or PO Box
                              </label>
                              <textarea class="form-control" disabled></textarea>


                            </div>
                            <div class="col-6" [formGroup]="form2">
                              <label>Social Security Number or ITIN</label>

                              <input type="text" class="form-control" disabled formControlName="ssn1"
                                (keypress)="keyPress($event)" minlength="9" maxlength="9">
                              <span class="req" *ngIf="form2.controls['ssn1'].invalid">

                                <p>*Enter Valid ssn ,Enter 9 digit</p>
                              </span>


                              <label>Minnesota or Federal Employer Identification Number (FEIN) (Sole
                                proprietors)</label>
                              <input type="text" class="form-control" disabled formControlName="Minnesota">

                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-4">
                              <label>Apt or Suite
                              </label>
                              <input type="text" class="form-control" disabled>
                            </div>
                            <div class="col-lg-4" [formGroup]="form2">
                              <label>Phone Number </label>
                              <input type="text" disabled class="form-control" formControlName="phone1"
                                (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)">
                              <span class="req" *ngIf="form2.controls['phone1'].invalid">

                                <p>*Enter Valid phone ,Enter 10 digit</p>
                              </span>
                            </div>
                            <div class="col-lg-4" [formGroup]="form2">
                              <label>Fax Number </label>
                              <input type="text" class="form-control" disabled formControlName="fax1"
                                (ngModelChange)="DemographicPhoneFormat();;" minlength="14" maxlength="14"
                                (keypress)="keyPress($event)">
                              <span class="req" *ngIf="form2.controls['fax1'].invalid">

                                <p>*Enter Valid fax,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                          <div class="row mt-2">

                            <div class="col-3">
                              <label>City
                              </label>
                              <input type="text" class="form-control" disabled>
                            </div>
                            <div class="col-2">
                              <label>State </label>

                              <ng-select  [items]="stateList" class="width25" [searchable]="true"
                                [clearable]="true" bindLabel="name" bindValue="abbreviation" style="pointer-events: none;">
                              </ng-select>
                            </div>
                            <div class="col-2" [formGroup]="form2">
                              <label>Zip Code </label>
                              <input type="string" (keypress)="keyPress($event)" maxlength="11" minlength="5" disabled
                                class="form-control" formControlName="zip1">
                              <span class="req" *ngIf="form2.controls['zip1'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                            <div class="col-5">
                              <label>Email Address </label>

                              <input type="text" disabled class="form-control">


                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\second.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-11">
                          <div class="row mt-2">
                            <div class="col-6">
                              <label>Name of Appointee</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.name_of_Appointee">
                              <label>Street Address or PO Box
                              </label>
                              <textarea class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_Street_Address_or_PoBox"></textarea>


                            </div>
                            <div class="col-6">
                              <label>Attorney Number,Accountant Number or PTIN</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_Attorney_Number_Accountant_Number_or_Ptin">
                              <label>Phone Number</label>
                              <div [formGroup]="form2">
                                <input type="text" class="form-control" formControlName="phone2"
                                  [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_PhoneNumber"
                                  (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                  (keypress)="keyPress($event)">
                                <span class="req" *ngIf="form2.controls['phone2'].invalid">

                                  <p>*Enter Valid phone,Enter 10 digit</p>
                                </span>
                              </div>

                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-6">
                              <label>Apt or Suite
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_Apt_or_Suite">
                            </div>

                            <div class="col-lg-6" [formGroup]="form2">
                              <label>Fax Number</label>
                              <input type="text" class="form-control" formControlName="fax2"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_FaxNumber"
                                (ngModelChange)="DemographicPhoneFormat();;" minlength="14" maxlength="14">
                              <span class="req" *ngIf="form2.controls['fax2'].invalid">

                                <p>*Enter Valid fax,Enter 10 digit</p>
                              </span>
                            </div>
                          </div>
                          <div class="row mt-2">

                            <div class="col-3">
                              <label>City
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_city">
                            </div>
                            <div class="col-2">
                              <label>State</label>

                              <ng-select
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_state"
                                [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation">
                              </ng-select>
                            </div>
                            <div class="col-2" [formGroup]="form2">
                              <label>Zip Code</label>
                              <input type="string" minlength="5" maxlength="11" class="form-control"
                                (keypress)="keyPress($event)" formControlName="zip2"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_Zipcode">
                              <span class="req" *ngIf="form2.controls['zip2'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digits</p>
                              </span>
                            </div>
                            <div class="col-5">
                              <label>Email Address</label>

                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.primary_Appointee_EmailAddress">


                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <p>If Appointing more than one person enter on page 2 of this form</p>

              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\third.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>

                        <div class="col-11">
                          <div class="row mt-2" style="padding-left:20px;">
                            <p>I appoint the person above and anyone included on the attached list,to access my
                              information and represent me before the Minnesota department of Revenue.This authority
                              does not cover powers listed in the additional powers section below unless indicated
                            </p>
                            <p>check the box for <b>Limited Authority</b> or <b>Full Authority</b></p>
                            <div class="col-lg-9">
                              <div class="row">

                                <table class="table table-bordered table-responsive">
                                  <thead>
                                    <tr>
                                      <div class="row ms-2" id="radi">
                                        <div class="col-1">
                                          <input type="radio" name="radiobtn" value="LimitedAuthority"
                                            [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.lLmitedAthourity">
                                        </div>
                                        <div class="col-5">
                                          <label><b>Limited Authority</b></label>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-lg-12">
                                          <p>The Appointee is authorized to act on behalf but only for the following
                                          </p>

                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-lg-9">
                                          <p>Type Of Tax(such as income Estate,Property Tax Refund,Withholding)or Dept
                                            issue</p>
                                        </div>

                                        <div class="col-lg-3" style="text-align: right;">
                                          <label style="text-align: right;">Years or Periods</label>
                                          <p style="text-align: right;">(if Left blanks applies to all)</p>
                                        </div>
                                      </div>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>

                                      <td><label>Withholding Tax</label></td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods1">
                                      </td>


                                    </tr>
                                    <tr>

                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax1">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods2">
                                      </td>


                                    </tr>
                                    <tr>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax2">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods3">
                                      </td>
                                    </tr>
                                    <tr>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Granted_Type_of_Tax3">
                                      </td>
                                      <td><input type="text" class="form-control"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.years_of_Periods4">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>

                              </div>

                            </div>
                            <div class="col-lg-3">
                              <div class="row">

                                <div class="card">
                                  <div class="card-body">

                                    <div class="row ms-2" id="radi">
                                      <div class="col-1">
                                        <input type="radio" name="radiobtn" value="FullAuthority"
                                          [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.lLmitedAthourity">
                                      </div>
                                      <div class="col-8">
                                        <label><b>Full Authority</b></label>
                                      </div>
                                    </div>
                                    <p class="card-text">this appointee is authorized to act on my behalf but only
                                      for all of my tax and debt issues for all years or periods</p>

                                  </div>
                                </div>

                              </div>

                            </div>


                          </div>
                          <div class="row mt-2 ms-3">
                            <div class="col-lg-5">
                              <label>Authority Expiration Date
                              </label>
                            </div>
                            <div class="col-lg-4">
                              <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [selDate]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authority_Experiation_Date"
                                placeholder="mm/dd/yyyy" (inputFieldChanged)="newdates($event,'inputchange','exdate')"
                                (dateChanged)="newdates($event,'datechanged','exdate')">

                              </my-date-picker>
                            </div>
                          </div>


                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">

                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\addpower.JPG" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-10">
                          <div class="row mt-2">
                            <p>Add the following powers to the appointees limited or full authority (check any that
                              apply)</p>
                          </div>
                          <div class="row mt-2">

                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.communicate_with_the_department_by_email">
                            </div>
                            <div class="col-lg-5">
                              <label>Communicate with the department by email</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.add_additional_appointees">
                            </div>
                            <div class="col-lg-5">
                              <label>Add additional appointees(primary Appointee only)</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.sign_returns_and_other_tax_forms">
                            </div>
                            <div class="col-lg-5">
                              <label>sign returns and other tax forms</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.receive_all_mail_except_refunds">
                            </div>
                            <div class="col-lg-5">
                              <label>Receive all mail except refunds(see instructions)(primary Appointee
                                only)</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.extend_statute_of_limitations_to_assess_tax">
                            </div>
                            <div class="col-lg-5">
                              <label>Extend statute of limitations to assess tax</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.authorize_the_department_to_release_return_information_third_parties">
                            </div>
                            <div class="col-lg-5">
                              <label>Authorize the department to release my return information to third
                                parties</label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.excute_Agreements">
                            </div>
                            <div class="col-lg-5">
                              <label>Excute Agreements</label>
                            </div>
                            <div class="col-lg-1">
                              <input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.act_on_my_behalf_i_became_incapacitated_or_incompetent">
                            </div>
                            <div class="col-lg-5">
                              <label>Act on my behalf if i became incapacitated or incompetent(Durable POA)</label>
                            </div>
                          </div>



                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-3">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:25px;">
                      <div class="row">
                        <div class="col-1">
                          <img src="..\assets\img\signature.jpg" class="img-fluid" alt="Responsive image"
                            style="text-align:center;">
                        </div>


                        <div class="col-10">
                          <div class="row mt-2">
                            <p>This power of Attorney is not valid until it is signed and dated by the Taxpayer</p>
                            <p>parent,Gurdian,conservation i certify that i have the legal authority to sign this
                              form</p>
                          </div>

                          <div class="row">
                            <div class="col-3">
                              <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#power" disabled>
                                Signature
                              </button>
                            </div>
                            <div class="col-lg-1">
                              <label for="cname">Date:</label>
                            </div>
                            <div class="col-lg-2">
                              <my-date-picker class="w-100" [disabled]="ClientTemplateBO?.datalist?.documentType!=null"
                                [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy">

                              </my-date-picker>
                            </div>
                            <div class="col-lg-3">
                              <label>Address If Different from Taxpayer</label>
                            </div>
                            <div class="col-lg-3">
                              <textarea class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.address_If_Different_from_Taxpayer"></textarea>
                            </div>
                          </div>
                          <div class="row mt-2 mb-2">

                            <div class="col-lg-4">
                              <input *ngIf="Partisign!=''&& Partisign!=null " type="image" src="{{Partisign}}"
                                class="form-control" style="width: 255px;height:120px;" alt="nurse" width="48"
                                height="48">
                            </div>
                          </div>

                          <p>Print Name and Title If applicable</p>
                          <div class="row mt-2">
                            <div class="col-lg-6">
                              <div class="row">
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.print_Name_and_If_applicable">
                                </div>
                                <div class="col-lg-6">

                                  <ng-select [items]="selflist" class="width25" [searchable]="true"
                                    style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                    bindValue="Key" placeholder="Choose One"
                                    [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.chooseTitleLid">
                                  </ng-select>
                                </div>
                              </div>


                            </div>
                            <div class="col-lg-6">
                              <div class="row">
                                <div class="col-lg-4">
                                  <label>Phone Number</label>
                                </div>
                                <div class="col-lg-6" [formGroup]="form2">


                                  <input type="text" class="form-control" formControlName="phone3"
                                    [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signPhoneNumber"
                                    (ngModelChange)="DemographicPhoneFormat();" minlength="14" maxlength="14"
                                    (keypress)="keyPress($event)">

                                  <span class="req" *ngIf="form2.controls['phone3'].invalid">

                                    <p>*Enter Valid phone ,Enter 10 digit</p>
                                  </span>
                                </div>
                              </div>


                            </div>



                          </div>
                          <div class="row mt-2">
                            <div class="col-4">
                              <label>City
                              </label>
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signature_City">
                            </div>
                            <div class="col-4">
                              <label>State</label>

                              <ng-select
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signature_State"
                                [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                bindLabel="name" bindValue="abbreviation">
                              </ng-select>
                            </div>
                            <div class="col-3" [formGroup]="form2">
                              <label>Zip Code</label>
                              <input type="string" minlength="5" maxlength="11" (keypress)="keyPress($event)"
                                class="form-control" formControlName="zip3"
                                [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.signature_Zipcode">

                              <span class="req" *ngIf="form2.controls['zip3'].invalid">

                                <p>*Enter Valid zip ,Enter 5 to 11 digit</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row mt-2 mb-3">
            <div class="col-12">
            <img src="..\assets\img\newaddress.JPG" class="img-fluid" alt="Responsive image"
              style="text-align:center;">
            </div>
            </div> -->
              <div class="row ms-2">
                <p><b>Send a signed copy of this form to the Deportment</b></p>
              </div>
              <div class="row ms-2">
                <p><b>Mail: &nbsp;&nbsp;Minnesota Deportment Of Revenue,Mail Station 4123,600N,Robert st.,st.Paul,MN
                    55146</b></p>
              </div>
              <div class="row ms-2">
                <p><b>FAX:&nbsp;&nbsp;651-556-5210</b></p>
              </div>
              <div class="row ms-2">
                <p><b>Email&nbsp;&nbsp;:MNDOR,POA@State.mn.us</b></p>
              </div>

              <div class="row mt-4">
                <div class="col-lg-12" style="text-align:center">
                  <h4><b>Additional Appointees</b></h4>
                </div>

              </div>

              <div class="row mt-3">
                <div class="col-lg-6">
                  <label>Name of Taxpayer</label>
                  <input type="text" class="form-control"
                    [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointee_Form1_Name_of_Taxpayer">
                </div>
                <div class="col-lg-6" [formGroup]="form2">
                  <label>SSN,ITIN,MN ID,or FEIN</label>
                  <input type="text" class="form-control" formControlName="ssn2"
                    [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointee_Form1_SsN_Itin_Mn_Id_or_Fein"
                    minlength="9" maxlength="9" (keypress)="keyPress($event)">
                  <span class="req" *ngIf="form2.controls['ssn2'].invalid">

                    <p>*Enter Valid ssn,Enter 9 digit</p>
                  </span>
                </div>
              </div>

              <div class="row mt-2 ms-2">
                <p>include any appointees below Additional appointees only have authority over matters choose in the
                  Authority Granted and Additional powers section on page 1.</p>
              </div>

              <div class="row mt-2 mb-3">
                <div id="goalaccordion" class="col-lg-12"
                  *ngFor="let item of OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress;let goal1=index">
                  <div class="col">
                    <div class="card ">

                      <div class="card-body" style="padding:25px;">

                        <div class="row">
                          <div class="col-lg-10">
                            <a style="color:#004290" data-bs-toggle="collapse"
                              attr.data-bs-target="#collapse_{{goal1}}">

                            </a>
                          </div>
                          <div class="col-lg-2 text-end">

                            <button class="btn btn-delete-table" *ngIf="goal1==0" (click)="CreateEvalue()"><i
                                class="fa fa-plus-circle"></i></button>

                            <button class="btn btn-delete-table" *ngIf="ContactColumn&&goal1!=0"
                              (click)="removeSelectEvalue(goal1);"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row mt-2">
                              <div class="col-6">
                                <label>Name of Appointee</label>

                                <input type="text" class="form-control" [(ngModel)]="item.nameofAppointee">
                                <label>Street Address or PO Box
                                </label>
                                <textarea class="form-control" [(ngModel)]="item.street_Address_or_PoBox"></textarea>


                              </div>
                              <div class="col-6">
                                <label>Attorney Number,Accountant Number or PTIN</label>

                                <input type="text" class="form-control"
                                  [(ngModel)]="item.attorneyNumber_AccountantNumber_or_Ptin">
                                <label>Phone Number</label>
                                <input type="text" class="form-control" [(ngModel)]="item.phoneNumber"
                                  (ngModelChange)="DemographicPhoneFormat();validchange1(goal1,item)" minlength="14"
                                  maxlength="14" (keypress)="keyPress($event)">
                                <span class="err" *ngIf="errphone1">{{phonerr1[goal1]}}</span>


                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-lg-6">
                                <label>Apt or Suite
                                </label>
                                <input type="text" class="form-control" [(ngModel)]="item.apt_or_Suite">
                              </div>

                              <div class="col-lg-6">
                                <label>Fax Number</label>
                                <input type="text" class="form-control" [(ngModel)]="item.faxNumber"
                                  (ngModelChange)="DemographicPhoneFormat();validchange2(goal1,item)" minlength="14"
                                  maxlength="14" (keypress)="keyPress($event)">
                                <span class="err" *ngIf="errphone2">{{phonerr2[goal1]}}</span>

                              </div>
                            </div>
                            <div class="row mt-2">

                              <div class="col-3">
                                <label>City
                                </label>
                                <input type="text" class="form-control" [(ngModel)]="item.city">
                              </div>
                              <div class="col-2">
                                <label>State</label>

                                <ng-select [(ngModel)]="item.state" [items]="stateList" class="width25"
                                  [searchable]="true" [clearable]="true" bindLabel="name" bindValue="abbreviation">
                                </ng-select>
                              </div>
                              <div class="col-2">
                                <label>Zip Code</label>
                                <input type="string" class="form-control" (keypress)="keyPress($event)"
                                  [(ngModel)]="item.zip" (ngModelChange)="validchange3(goal1,item)" maxlength="11"
                                  minlength="5">
                                <span class="err" *ngIf="ziperr">{{ziperr[goal1]}}</span>

                              </div>
                              <div class="col-5">
                                <label>Email Address</label>

                                <input type="text" class="form-control" [(ngModel)]="item.email">




                              </div>
                            </div>

                          </div>

                        </div>


                      </div>
                    </div>
                  </div>
                </div>




              </div>
            </div>

            <!-- <div class="card-footer">
              <div class="row">

                <div class="col text-end mb-3 mt-3">

                  <button type="button" class="btn blue-btn me-3"
                    class="btn blue-btn" (click)="save()">Save</button>
                 
                  <button type="button" class="btn blue-btn ms-3" data-bs-dismiss="modal" (click)="clearindivualbo()"
                    >Clear</button>
                </div>

              </div>
            </div> -->
          </div>
        </div>



      </div>
      <!-- </div> -->
    </div>



  </div>
</div>






<div class="row mb-2">
  <div class="col-lg-12">
    <div class="card">
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <!-- <button class="btn blue-btn" (click)="PreviouspageRouter()">Previous</button> -->
              </div>

              <!-- <div class="text-end">
                  </div>&nbsp;&nbsp; -->
              <!-- <div class=" text-end">
                      <button class="btn blue-btn">Submit</button>
                  </div> -->
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>




  
   

<span id="deleteFEAmodal" data-bs-toggle="modal" data-bs-target="#deleteModal"></span>
<div class="modal" tabindex="-1" role="dialog" id="deleteModal" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Delete </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"> </span>
        </button>
      </div>
      <div class="modal-body">
        <p>Do you want to delete this document?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn">Yes</button>
        <button type="button" class="btn blue-btn" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="signid" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #signpadone [options]="signaturePadOptions" (onEndEvent)="here()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Clear()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="signhere2" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #signpadtwo [options]="signaturePadOptions" (onEndEvent)="here2()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Clear2()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="user" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #userpad [options]="signaturePadOptions" (onEndEvent)="user()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearuser()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- <div class="modal fade" id="Taxpayer" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #Taxpayerpad [options]="signaturePadOptions"
          (onEndEvent)="Taxpayer()"></signature-pad>


          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearTaxpayer()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Appointeepad" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close"data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #Appointeepad [options]="signaturePadOptions"
          (onEndEvent)="Appointee()"></signature-pad>


          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearAppointee()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Spouse" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #Spousepad [options]="signaturePadOptions"
          (onEndEvent)="Spouse()"></signature-pad>


          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearSpouse()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="modal fade" id="Participant" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close"data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #Participantpad [options]="signaturePadOptions"
          
                   (onEndEvent)="Participant()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearParticipant()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->
<div class="modal fade" id="Participant2" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>







            <signature-pad #pantpad [options]="signaturePadOptions" (onEndEvent)="pant()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearpant()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="power" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #powerpad [options]="signaturePadOptions" (onEndEvent)="Parti()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearParti()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Participant3" data-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header"> Sign</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"> </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-12">
            <h4> Sign here</h4>

            <signature-pad #pantpad1 [options]="signaturePadOptions" (onEndEvent)="pant1()"></signature-pad>

          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="clearpant1()">Clear</button>
        <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

